var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerSolarUnitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#000000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m104.23-100.77 71.93-359.61h607.3l71.92 359.61H104.23ZM133.85-800v-60h114.23v60H133.85ZM178-160.77h272V-250H195.92L178-160.77Zm64.69-428.15-42.77-41.77 80.77-80.77 42.77 41.77-80.77 80.77ZM208.08-310H450v-90.38H226L208.08-310ZM480-679.62q-75.31 0-128.04-52.73-52.73-52.73-52.73-128.03h60q0 50.32 35.24 85.54 35.24 35.23 85.58 35.23 50.33 0 85.53-35.23 35.19-35.22 35.19-85.54h60q0 75.3-52.73 128.03-52.73 52.73-128.04 52.73Zm0-180.76Zm-30 344.23v-114.23h60v114.23h-60Zm60 355.38h271.62L763.69-250H510v89.23ZM510-310h241.54l-17.92-90.38H510V-310Zm208.08-278.54-80.54-81.15 41.77-41.77 81.54 80.15-42.77 42.77ZM711.92-800v-60h114.23v60H711.92Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerSolarUnitIcon);
export default __webpack_public_path__ + "static/media/marker-solarUnit-icon.6da060e277d739495f57954e8bad071b.svg";
export { ForwardRef as ReactComponent };